var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 41,
    viewBox: "0 0 44 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_235_1069)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.2066 21.9678C29.0169 21.9678 24.81 26.1749 24.81 31.3648C24.81 36.5546 29.0169 40.7617 34.2066 40.7617C39.3963 40.7617 43.6032 36.5545 43.6032 31.3648C43.6032 26.1749 39.3963 21.9678 34.2066 21.9678ZM9.79311 21.9687C4.60357 21.9687 0.396484 26.1749 0.396484 31.3648C0.396484 36.5546 4.60357 40.7617 9.79311 40.7617C14.983 40.7617 19.1902 36.5545 19.1902 31.3648C19.1902 26.1749 14.983 21.9687 9.79311 21.9687ZM31.3965 10.2218C31.3965 15.4117 27.1894 19.6193 22 19.6193C16.8102 19.6193 12.6032 15.4117 12.6032 10.2218C12.6032 5.03245 16.81 0.825195 21.9999 0.825195C27.1892 0.825195 31.3961 5.03279 31.3961 10.2217",
    fill: "#F06A6A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_235_1069"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43.2087,
    height: 40,
    fill: "white",
    transform: "translate(0.395508 0.825195)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo4);
export default __webpack_public_path__ + "static/media/logo4.9dd38e12a9fb29d59a9aeb05b0660aad.svg";
export { ForwardRef as ReactComponent };